import React from "react";

interface Props {
  desc?: string;
  customErrorText?: React.ReactNode;
  errorMetadata?: any;
}

export const ServerError: React.FC<Props> = props => {
  if (props.customErrorText) {
    return <>{props.customErrorText}</>;
  }

  return (
    <div>
      <b>Error loading content.</b>
      <br />
      Please contact technical support at{" "}
      <a href="mailto:support@havenconnect.com">support@havenconnect.com</a>
    </div>
  );
};
